




































































































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const userModule = namespace('user');

@Component
export default class NavigationSidebar extends Vue {

    @userModule.Getter('isCustomerExperienceExecutive') private isCustomerExperienceExecutive!: boolean;
    @userModule.Getter('isCustomerExperienceExecutiveTeamLeader') private isCustomerExperienceExecutiveTeamLeader!: boolean;
    @userModule.Getter('isDataCreationExecutive') private isDataCreationExecutive!: boolean;
    @userModule.Getter('isDataCreationTeamLeader') private isDataCreationTeamLeader!: boolean;
    @userModule.Getter('isHeadOfCustomerExperienceTeam') private isHeadOfCustomerExperienceTeam!: boolean;
    @userModule.Getter('isInternalKeyStakeholder') private isInternalKeyStakeholder!: boolean;
    @userModule.Getter('isDuplicateManager') private isDuplicateManager!: boolean;
    @userModule.Getter('isHeadOfDepartment') private isHeadOfDepartment!: boolean;
    @userModule.Getter('isProbateLegalAdvisor') private isProbateLegalAdvisor!: boolean;

    private get showTasksRoute(): boolean {
        return this.isInternalKeyStakeholder
            || this.isCustomerExperienceExecutiveTeamLeader
            || this.isCustomerExperienceExecutive
            || this.isDataCreationTeamLeader
            || this.isDataCreationExecutive
            || this.isProbateLegalAdvisor;
    }

    private get showCallRoutes(): boolean {
        return this.showMyCallsRoute
            || this.showCallManagementRoute;
    }

    private get showMyCallsRoute(): boolean {
        return this.isHeadOfCustomerExperienceTeam
            || this.isCustomerExperienceExecutiveTeamLeader
            || this.isCustomerExperienceExecutive;
    }

    private get showCallManagementRoute(): boolean {
        return this.isInternalKeyStakeholder
            || this.isHeadOfCustomerExperienceTeam
            || this.isCustomerExperienceExecutiveTeamLeader;
    }

    private get showDataRoutes(): boolean {
        return this.showDataImportRoute
            || this.showDataExportsRoute
            || this.showExceptionReportsRoute
            || this.showManageDuplicateClientsRoute;
    }

    private get showDataImportRoute(): boolean {
        return this.isInternalKeyStakeholder;
    }

    private get showDataExportsRoute(): boolean {
        return this.isInternalKeyStakeholder
            || this.isHeadOfCustomerExperienceTeam
            || this.isCustomerExperienceExecutiveTeamLeader
            || this.isDataCreationTeamLeader;
    }

    private get showExceptionReportsRoute(): boolean {
        return this.isInternalKeyStakeholder
            || this.isHeadOfDepartment
            || this.isDataCreationTeamLeader
            || this.isCustomerExperienceExecutiveTeamLeader
            || this.isHeadOfCustomerExperienceTeam;
    }

    private get showManageDuplicateClientsRoute(): boolean {
        return this.isInternalKeyStakeholder
            || this.isDuplicateManager;
    }
}
